import React from 'react';
import { string } from 'prop-types';
import { BadgeContainer, BadgeText, IndicatorContainer } from './badge.style';
import { BADGE_TYPES } from '../../../../constants';
import SmartFilterIndicator from '../smart-filter-indicator';

/**
 * Renders a badge given the type
 * @param {object} param - Object containing props
 * @param {string} param.type - Type of badge to show
 * @return {element} - Renders a badge given a type
 */
const Badge = ({ type }) => {
  /**
   * Get the text content of this badge
   * based on it's type.
   * @return {string} - Badge text
   */
  const getBadgeText = () => {
    switch (type) {
      case BADGE_TYPES.late:
        return 'Late';
      default:
        return 'Late';
    }
  };

  /**
   * Get the indicator of this badge
   * based on it's type.
   * @return {element} - Badge indicator
   */
  const getBadgeIndicator = () => {
    switch (type) {
      case BADGE_TYPES.late:
        return (
          <SmartFilterIndicator
            type="diamond"
            color="white"
            size="12"
            opacity="1.0"
          />
        );
      default:
        return (
          <SmartFilterIndicator
            type="diamond"
            color="white"
            size="12"
            opacity="1.0"
          />
        );
    }
  };

  return (
    <BadgeContainer type={type}>
      <IndicatorContainer>
        {getBadgeIndicator()}
      </IndicatorContainer>
      <BadgeText>{getBadgeText()}</BadgeText>
    </BadgeContainer>
  );
};

Badge.propTypes = {
  type: string,
};

Badge.defaultProps = {
  type: BADGE_TYPES.late,
};

export default Badge;
